import { Coverage } from "./DlpFlow.interfaces";

export const isCoveragesComplete = (coverages: Partial<Coverage>[]) => {
  if (coverages.length === 0) {
    return false;
  }

  return coverages.every(isCoverageComplete);
};

const isCoverageComplete = (coverage: Partial<Coverage>) => {
  const hasValidEffectiveDateAndInsured =
    Boolean(coverage.effectiveInsured && coverage.effectiveInsured.length > 0) &&
    Boolean(coverage.effectiveDate && coverage.effectiveDate.length === 10);
  const hasValidInsuranceType =
    Boolean(coverage.insuranceType) && Boolean(coverage.insuranceType === "Annuity" ? coverage.reductionRate : true);

  return (
    hasValidEffectiveDateAndInsured &&
    Boolean(coverage.hasInsuredAmount) &&
    Boolean(coverage.hasDuration) &&
    hasValidInsuranceType
  );
};
